import React, { useState } from 'react';
import { Button } from 'modules';
import { useMutation } from '@apollo/react-hooks';
import { ReportSignContractOnlineFormMutation } from 'queries/ContractOnlineForms/ContractOnlineFormData';
import { notifyFailed, notifySuccess } from 'helpers/notify';
import SignWithSms from 'components/SignWithSms';

interface ConfirmToSignData {
  form: {
    id: string;
  };
  mobil: string;
}

interface ButtonAcceptToSignReportProps {
  disabled?: boolean;
  data: ConfirmToSignData;
  onSubmit: () => void;
}

const ButtonAcceptToSignReport = ({ data, disabled, onSubmit }: ButtonAcceptToSignReportProps) => {
  const [displayConfirm, setDisplayConfirm] = useState(false);
  const [reportSignForm] = useMutation(ReportSignContractOnlineFormMutation);

  const toggleOpenConfirm = (): void => {
    setDisplayConfirm((prev) => !prev);
  };

  const onSubmitSign = (signature: GQL.ISignature) => {
    // uložím potvrzení podpisu formuláře
    reportSignForm({
      variables: {
        id: data.form.id,
        signatureId: signature.id,
      },
    })
      .then((result) => result.data.reportSignContractOnlineForm)
      .then((result) => {
        if (result) {
          notifySuccess('Odovzdanie bolo podpísané!');
          onSubmit();
        }
      })
      .catch((error) => {
        notifyFailed(error.message);
      });
  };

  return (
    <>
      <Button type={'submit'} variant={'danger'} className="ml-1" disabled={disabled} onClick={toggleOpenConfirm}>
        Podpísať odovzdania posudku Oddlženie BONATO
      </Button>
      {displayConfirm === true && (
        <SignWithSms
          title="Potvrdenie odovzdanie posudku"
          labelSignFor="potvrdenie odovzdanie posudku"
          labelSubmit="Podpísať"
          phone={data.mobil}
          onSubmit={onSubmitSign}
          onClose={toggleOpenConfirm}
        />
      )}
    </>
  );
};

export default ButtonAcceptToSignReport;
